import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { connect, useDispatch } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import * as auth from "../_redux/authRedux";
import { login } from "../_redux/authCrud";
import Swal from "sweetalert2";
import { fetchSynch } from "../../../pages/company/companySlice";
import { useHistory } from "react-router";
import { fetchDataAllCompany } from "../../../pages/user/userSlice";
import { paramsMasterAll } from "../../../utility";
import { RemoveRedEye } from "@material-ui/icons";
import { fetchSetting } from "../../../pages/setting/settingSlice";

/*
  INTL (i18n) docs:
  https://github.com/formatjs/react-intl/blob/master/docs/Components.md#formattedmessage
*/

/*
  Formik+YUP:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
*/

const initialValues = {
  username: "",
  password: "",
};
if (process.env.NODE_ENV === "development") {
  initialValues.username = "super_ikhsan";
  initialValues.password = "@#Superpvr4";
}

function Login(props) {
  const { intl } = props;
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();
  const LoginSchema = Yup.object().shape({
    username: Yup.string().required(
      intl.formatMessage({
        id: "AUTH.VALIDATION.REQUIRED_FIELD",
      })
    ),
    password: Yup.string().required(
      intl.formatMessage({
        id: "AUTH.VALIDATION.REQUIRED_FIELD",
      })
    ),
  });

  const [showPassword, setShowPassword] = useState(false);

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const enableLoading = () => {
    setLoading(true);
  };

  const disableLoading = () => {
    setLoading(false);
  };

  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };

  const formik = useFormik({
    initialValues,
    validationSchema: LoginSchema,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      enableLoading();
      setTimeout(async () => {
        try {
          const response = await login(values.username, values.password);
          console.log(response, "response");
          if (response.data.status_code === 401) {
            Swal.fire({
              title: "Error!",
              text: `${response.data.message}`,
              icon: "error",
              heightAuto: false,
              confirmButtonText: "Ok",
            }).then((result) => {});
          } else if (
            response.data.status_code === 200 &&
            response.data.user.use_default_password === true
          ) {
            Swal.fire({
              title: "info!",
              text: `Please Reset Your Password first!`,
              icon: "info",
              heightAuto: false,
              confirmButtonText: "Ok",
            }).then((result) => {
              // dispatch(props.logout());

              history.push("/auth/reset-password", {
                params: response.data.user,
              });
            });
          } else if (response.data.status_code === 200) {
            if (response.data.user.roles === "Company Sales") {
              Swal.fire({
                title: "Error!",
                text: `Company Sales Cannot Login Web`,
                icon: "error",
                heightAuto: false,
                confirmButtonText: "Ok",
              }).then((result) => {});
            } else {
              const token = response.data.access_token;

              props.login(token);
              await dispatch(fetchSetting({ ...paramsMasterAll }));
              await dispatch(fetchDataAllCompany({ ...paramsMasterAll }));

              disableLoading();
            }
          } else {
            Swal.fire({
              title: "Error!",
              text: `${response.data.message}`,
              icon: "error",
              heightAuto: false,
              confirmButtonText: "Ok",
            }).then((result) => {});
          }
        } catch (error) {
          setStatus(
            intl.formatMessage({
              id: "AUTH.VALIDATION.INVALID_LOGIN",
            })
          );
        } finally {
          disableLoading();
          setSubmitting(false);
        }
      }, 1000);
    },
  });

  return (
    <div className="login-form login-signin" id="kt_login_signin_form">
      {/* begin::Head */}
      <div className="text-center mb-10 mb-lg-20">
        <h3 className="font-size-h1">
          <FormattedMessage id="AUTH.LOGIN.TITLE" />
        </h3>
        <p className="text-white font-weight-bold">
          Enter your username and password
        </p>
      </div>
      {/* end::Head */}

      {/*begin::Form*/}
      <form
        onSubmit={formik.handleSubmit}
        className="form fv-plugins-bootstrap fv-plugins-framework"
      >
        <div className="form-group fv-plugins-icon-container">
          <input
            placeholder="username"
            type="username"
            className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
              "username"
            )}`}
            name="username"
            {...formik.getFieldProps("username")}
          />
          {formik.touched.username && formik.errors.username ? (
            <div className="fv-plugins-message-container">
              <div className="fv-help-block text-white">
                {formik.errors.username}
              </div>
            </div>
          ) : null}
        </div>
        <div className="form-group fv-plugins-icon-container">
          <div className="input-group">
            <input
              placeholder="Password"
              type={showPassword ? "text" : "password"}
              className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
                "password"
              )}`}
              name="password"
              {...formik.getFieldProps("password")}
            />
            <div className="input-group-append">
              <span
                className="input-group-text"
                onClick={toggleShowPassword}
                style={{ cursor: "pointer" }}
              >
                <RemoveRedEye />
              </span>
            </div>
          </div>
          {formik.touched.password && formik.errors.password ? (
            <div className="fv-plugins-message-container">
              <div className="fv-help-block text-white">
                {formik.errors.password}
              </div>
            </div>
          ) : null}
        </div>
        <div className="form-group d-flex flex-wrap justify-content-between align-items-center">
          <Link
            to="/auth/forgot-password"
            className="text-dark-50 text-hover-primary my-3 mr-2"
            id="kt_login_forgot"
          >
            {/* <FormattedMessage id="AUTH.GENERAL.FORGOT_BUTTON" /> */}
          </Link>
          <button
            id="kt_login_signin_submit"
            type="submit"
            disabled={formik.isSubmitting}
            className={`btn btn-white font-weight-bold px-9 py-4 my-3`}
          >
            <span>Sign In</span>
            {loading && <span className="ml-3 spinner spinner-dark"></span>}
          </button>
        </div>
      </form>
      {/*end::Form*/}
    </div>
  );
}

export default injectIntl(connect(null, auth.actions)(Login));
